module.exports = __webpack_public_path__ + "static/img/14001040.c75bf0e0.png";